import { theme } from '@garnish/constants';

export const CHECKBOX_SIZE = 24;
export const CHECKBOX_BG_COLOR = theme.colors.WHITE;
export const CHECKBOX_COLOR = theme.colors.KALE;
export const CHECKBOX_DISABLED_COLOR = theme.colors.GRAY;
export const CHECKBOX_HOVER_COLOR = theme.colors.OPACITY.KALE.LIGHTEST;
export const CHECKBOX_ICON_COLOR = CHECKBOX_BG_COLOR;
export const CHECKBOX_ICON_SIZE = 16;
